import React from 'react';

import t from '../../../labels/labelling-utils';
import { IComponent } from '../../../typings/generic-component';
import { makeClassNames } from '../../../utils/styles';
import { Cta } from '../../atoms';
import './simple-pagination.scss';

export interface ISimplePagination extends IComponent {
  prevLink?: string;
  nextLink?: string;
  trackingData?: {
    prev: object;
    next: object;
  };
}

const classNames = () =>
  makeClassNames({
    simplePagination: 'simple-pagination',
    button: 'simple-pagination__button',
  });

const SimplePagination = ({ prevLink, nextLink, trackingData }: ISimplePagination) => {
  const cn = classNames();

  return (
    <div className={cn.simplePagination}>
      {prevLink && (
        //   data-intcmp={`skysports_livedata_liveblog_prev-page_${prevPageNumber}`}
        <Cta
          className={cn.button}
          iconPosition="left"
          href={prevLink}
          trackingData={trackingData?.prev}
          iconCustomSize={{ width: '18', height: '24' }}
        >
          {t('simple-pagination.button.label.prev')}
        </Cta>
      )}

      {nextLink && (
        //   data-intcmp={`skysports_livedata_liveblog_next-page_${nextPageNumber}`}
        <Cta
          className={cn.button}
          iconPosition="right"
          href={nextLink}
          trackingData={trackingData?.next}
          iconCustomSize={{ width: '18', height: '24' }}
        >
          {t('simple-pagination.button.label.next')}
        </Cta>
      )}
    </div>
  );
};

export default SimplePagination;
